const UNSUPPORTED_DEVICES = ['mobile', 'tablet'];

export const deviceSupportsDrafts = (deviceType: string) =>
  !UNSUPPORTED_DEVICES.includes(deviceType);
